import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from './my-contacts.reducer';

export const selectState = createFeatureSelector<State>('myContacts');
export const selectManagers = createSelector(selectState, (state: State) => state.managers);
